<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <dl class="row">
    <div class="container">
      <div class="dialog-title">New Hunt Template</div>
      <div class="dialog-subtitle">
        Group hunt packages for repeatable hunts.
      </div>
      <cyborg-error *ngIf="error" [error]="error"></cyborg-error>
      <form
        class="k-form"
        [formGroup]="formGroup"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
      >
        <kendo-formfield>
          <label for="name">Name*</label>
          <input id="name" maxlength="50" formControlName="name" kendoTextBox />
          <kendo-formerror>Error: Name is required</kendo-formerror>
          <kendo-formfield>
            <label for="environments">Environment</label>
            <kendo-multiselect
              [data]="environments"
              textField="name"
              valueField="id"
              placeholder="Environments"
              formControlName="environments"
              (valueChange)="onValueChange()"
            >
            </kendo-multiselect>
          </kendo-formfield>
        </kendo-formfield>
        <div class="k-two-col">
          <kendo-formfield>
            <label for="priority">Priority*</label>
            <kendo-dropdownlist
              formControlName="priority"
              [data]="priorities"
              defaultItem="Select..."
            >
            </kendo-dropdownlist>
            <kendo-formerror>Error: Priority is required</kendo-formerror>
          </kendo-formfield>
          <kendo-formfield>
            <label for="defaultAssignee">Default Assignee</label>
            <kendo-dropdownlist
              textField="fullName"
              valueField="id"
              formControlName="defaultAssignee"
              [data]="assignees$ | async"
            >
            </kendo-dropdownlist>
          </kendo-formfield>
        </div>
        <kendo-formfield>
          <kendo-label
            [for]="description"
            text="Abstract*"
            class="customizing-label"
          ></kendo-label>
          <kendo-textarea
            #description
            name="description"
            formControlName="description"
            placeholder="Include a short description of the hunt's purpose and background."
            [maxlength]="10000"
          >
          </kendo-textarea>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label
            [for]="hypothesis"
            text="Hypothesis*"
            class="customizing-label"
          ></kendo-label>
          <kendo-textarea
            #hypothesis
            name="hypothesis"
            formControlName="hypothesis"
            resizable="vertical"
            placeholder="Provide a proposed explanation to be used as a starting point for further investigation."
            [maxlength]="10000"
          >
          </kendo-textarea>
        </kendo-formfield>
        <!-- <kendo-formfield>
          <kendo-label
            for="planned"
            text="Planned"
            class="customizing-label"
          ></kendo-label>
          <kendo-switch
            formControlName="planned"
            onLabel="Yes"
            offLabel="No"
          ></kendo-switch>
        </kendo-formfield> -->
        <!-- <div class="k-two-col">
          <kendo-formfield>
            <label for="name">Repeat</label>
            <kendo-dropdownlist
              formControlName="repeat"
              [data]="repeatOptions"
            >
            </kendo-dropdownlist>
            <kendo-formerror>Error: Repeat is required</kendo-formerror>
          </kendo-formfield>
          <kendo-formfield>
            <label for="Every">Every</label>
            <kendo-dropdownlist
              formControlName="every"
              [data]="everyOptions"
            >
            </kendo-dropdownlist>
            <kendo-formerror>Error: Every is required</kendo-formerror>
          </kendo-formfield>
        </div> -->
        <button
          themeColor="primary"
          class="dialog-button"
          size="large"
          type="submit"
          [disabled]="!formGroup.valid"
          kendoButton
        >
          Save
        </button>
      </form>
    </div>
  </dl>
</div>
